import React from 'react';
import ReactDOM from 'react-dom';
// import './style.css';
import './style1.css';

// import './lib/bootstrap/css/bootstrap.min.css';

import './default.css';
import './lib/font-awesome/css/font-awesome.min.css';
import './lib/flaticon/font/flaticon.css';
// import './lib/animate/animate.min.css';
import './lib/ionicons/css/ionicons.min.css';
import './lib/owlcarousel/assets/owl.carousel.min.css';


import App from './App';

const url = new URL(window.location.href);
window.customColor = url.searchParams.get("color") ? '#' + url.searchParams.get("color") : null;

ReactDOM.render(
    <div>
        <style>
            {`\
                .property .fwicons {\
                    color: ${window.customColor};\
                }\
                .sidebar-widget input {\
                    color: ${window.customColor} !important;\
                }\
                .sidebar-widget span.MuiSlider-thumb {\
                    color: ${window.customColor} !important;\
                }\
                .sidebar-widget span.MuiCheckbox-root {\
                    color: ${window.customColor};\
                }\
                .sidebar-widget .MuiSlider-rail  {\
                    color: ${window.customColor};\
                }\
                .sidebar-widget .MuiSlider-track {\
                    color: ${window.customColor};\
                }\
                .sidebar-widget .outlined-button-file * {\
                    color: ${window.customColor} !important;\
                }\
                .sidebar-widget .makeStyles-slider-246 {\
                    color: ${window.customColor};\
                }\
                .sidebar-widget .makeStyles-button-272 * {\
                    color: ${window.customColor} !important;\
                }\
                .sidebar-widget .jss272 {\
                    color: ${window.customColor} !important;\
                }\
                .backToListBtn .fwicons {\
                    color: ${window.customColor};\
                }\
                .container .heading-properties h3 span {\
                    color: ${window.customColor};\
                }\
                .heading-properties .fwicons {\
                    color: ${window.customColor};\
                }\
                .popular-posts .media-body .media-heading a {\
                   color: ${window.customColor};\
               }\
               .container .tab-pane .fwicons {\
                  color: ${window.customColor};\
              }\
              .contact-form .button-theme.contact-btn {\
                    background: ${window.customColor};\
                    border-color: ${window.customColor};\
             }\
            `}
        </style>
        <App />
    </div>
, document.getElementById('root'));
